import script from "./TimerBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimerBar.vue?vue&type=script&setup=true&lang=ts"

import "./TimerBar.vue?vue&type=style&index=0&id=a944a6f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a944a6f6"]])

export default __exports__